import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from '../../../_services/order.service';

// Bounces straight back to the edit page. Going through here is how the edit
// page starts fresh for another order (previous / next), since navigating to
// the same route would reuse the component and keep the old order's state.
@Component({
  selector: 'app-edit-sale-reload',
  standalone: true,
  template: '',
})
export class EditSaleReloadComponent implements OnInit {
  constructor(private router: Router, private orderService: OrderService) {}

  ngOnInit(): void {
    const orderNo = this.orderService.getEditingOrderNo();
    this.router.navigate(orderNo ? ['sales', orderNo] : ['sales'], { replaceUrl: true });
  }
}
